export const appArrowRightMoIcon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.08" cx="20" cy="20" r="20" fill="#4F4F4F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6001 15.4L19.0001 14L25.0001 20L19.0001 26L17.6001 24.6L22.2001 20L17.6001 15.4Z" fill="#4F4F4F"/></svg>`,
    name: 'arrow-right-mo'
};